/**
 * @generated SignedSource<<f68fca1cb35f25ae4383293c3712f905>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SlackIntegrationUninstallMutation$variables = Record<PropertyKey, never>;
export type SlackIntegrationUninstallMutation$data = {
  readonly uninstallSlack: {
    readonly error: string | null | undefined;
    readonly success: boolean;
  };
};
export type SlackIntegrationUninstallMutation = {
  response: SlackIntegrationUninstallMutation$data;
  variables: SlackIntegrationUninstallMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "UninstallSlackPayload",
    "kind": "LinkedField",
    "name": "uninstallSlack",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SlackIntegrationUninstallMutation",
    "selections": (v0/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "SlackIntegrationUninstallMutation",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "99254b0c01fd90e36cae84f109cfa78d",
    "id": null,
    "metadata": {},
    "name": "SlackIntegrationUninstallMutation",
    "operationKind": "mutation",
    "text": "mutation SlackIntegrationUninstallMutation {\n  uninstallSlack {\n    success\n    error\n  }\n}\n"
  }
};
})();

(node as any).hash = "3d926b8fade8e5e4b3fc082e3fd04ac8";

export default node;
